import bemBlock from '@gik/core/utils/bemBlock';
import { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import { useInkindStore } from '@gik/inkind-page/store/InkindStore';
import { Badge } from '@gik/ui/Badge';
import { Button } from '@gik/ui/Button';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import UserGroupIcon from '@heroicons/react/solid/UserGroupIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';

type InkindSupportersButtonProps = {
  num: number;
  displayNumSupporters?: boolean;
};

export default function InkindSupportersButton({
  num,
  displayNumSupporters,
  ...otherProps
}: InkindSupportersButtonProps): JSX.Element {
  const { t } = useTranslation();
  const bem = bemBlock('inkind-supporters-button');
  const inkindRouteId = useInkindStore(store => store.inkindRouteId);

  return (
    <Button
      type={'a'}
      href={`/inkinds/${inkindRouteId}/admin/supporters`}
      id={inkindPageTourSelectors.supportersButton}
      className={bem()}
      block
      pill
      size="lg"
      customIconSize
      variant="secondary"
      prepend={<SvgIcon Icon={UserGroupIcon} />}
      append={
        displayNumSupporters &&
        num > 0 && (
          <Badge size="xs" variant="white" pill>
            {num}
          </Badge>
        )
      }
      {...otherProps}
    >
      {t(translationKeys.SupportersButton).toString()}
    </Button>
  );
}
